module.exports = "/_next/static/images/Key@3x-71864372c3a2ce3673298a32d61b94aa.png";